import * as React from 'react';
import styled from 'styled-components';

interface BoxContainerProps {
  disabled?: boolean;
}

export default styled.div<BoxContainerProps>`
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid ${({theme}) => theme.variables.borderColor};
  background: ${({theme}) => theme.variables.accentBackgroundColor};
  box-shadow: 3px 10px 20px ${({theme}) => theme.variables.boxShadowColor};
  opacity: ${({disabled}) => disabled && '.5'};
  pointer-events: ${({disabled}) => disabled && 'none'};
`;
